const AppStoreBadge = () => (
  <svg
    width="140"
    height="47"
    viewBox="0 0 140 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.5"
      y="0.5"
      width="139"
      height="46"
      rx="7.5"
      fill="white"
      stroke="#A6A6A6"
    />
    <path
      d="M31.1 23.55c-.03-3.13 2.58-4.64 2.7-4.71a5.88 5.88 0 0 0-4.63-2.5c-1.95-.2-3.83 1.16-4.83 1.16-1.01 0-2.54-1.14-4.18-1.11a6.16 6.16 0 0 0-5.19 3.16c-2.23 3.85-.57 9.53 1.58 12.65 1.06 1.54 2.31 3.27 3.95 3.21 1.59-.07 2.19-1.02 4.11-1.02 1.91 0 2.47 1.02 4.15.98 1.71-.03 2.78-1.55 3.82-3.1a13.1 13.1 0 0 0 1.73-3.54 5.49 5.49 0 0 1-3.11-4.18z"
      fill="#333"
    />
    <path
      d="M28.07 14.28a5.56 5.56 0 0 0 1.28-3.99 5.66 5.66 0 0 0-3.66 1.9 5.28 5.28 0 0 0-1.31 3.83 4.69 4.69 0 0 0 3.69-1.74z"
      fill="#333"
    />
    <text
      x="42"
      y="17"
      fill="#333"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="9"
      fontWeight="400">
      Disponível na
    </text>
    <text
      x="42"
      y="33"
      fill="#333"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="16"
      fontWeight="600">
      App Store
    </text>
  </svg>
)

export default AppStoreBadge
